import { render, staticRenderFns } from "./ModernDateRangeSelector.vue?vue&type=template&id=136dc51a&"
import script from "./ModernDateRangeSelector.vue?vue&type=script&lang=js&"
export * from "./ModernDateRangeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports